<template>
    <div class="dropdown greek-symbol">
        <slot></slot>
        <template v-if="isGreekCharactersAllowed">
            <button v-bind:id="'dLabel' + lineId" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                &#937;
            </button>
            <div class="dropdown-menu" v-bind:aria-labelledby="'dLabel' + lineId">
                <h4>Add these Greek letters</h4>
                <div class="row symbols-list">
                    <div class="col-5" v-for="letter in alphabet">
                        <a class="btn btn-default" v-html="letter"
                            v-bind:value="letter"
                            v-on:click.stop.prevent="onGreek(letter)"
                        ></a>
                    </div>
                </div>
                <div class="row no-gutter">
                    <a v-on:click="onClose" class="btn btn-success">Close</a>
                    <a v-on:click.stop.prevent="onClear" class="btn btn-danger">Clear</a>
                </div>
            </div>
        </template>
    </div>
</template>
<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import CampaignConfigurationMixin from '../../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import InscriptionEditMixin from '../../../../../assets/js/components/frontend/mixin/inscription-edit.vue'
    export default {
        name: 'greek-letters-dropdown',
        mixins: [
            CampaignConfigurationMixin,
            InscriptionEditMixin
        ],
        data: function () {
            return this.getDefaultData();
        },
        props: {
            lineId: {
                type: String,
                required: true
            }
        },
        methods: {
            getDefaultData: function () {
                return {
                    alphabet: [ // Greek capital letters
                        '&#913;',
                        '&#914;',
                        '&#915;',
                        '&#916;',
                        '&#917;',

                        '&#918;',
                        '&#919;',
                        '&#920;',
                        '&#921;',
                        '&#922;',

                        '&#923;',
                        '&#924;',
                        '&#925;',
                        '&#926;',
                        '&#927;',

                        '&#928;',
                        '&#929;',
                        '&#931;',
                        '&#932;',
                        '&#933;',

                        '&#934;',
                        '&#935;',
                        '&#936;',
                        '&#937;'
                    ]
                }
            },
            onGreek: function (entity) {
                var txt = document.createElement("textarea");
                txt.innerHTML = entity;
                var letter = txt.value;
                Event.$emit('addLetter', { letter: letter, id: this.lineId });
            },
            onClear: function () {
                Event.$emit('addLetter', { action: 'clear', id: this.lineId });
            },
            onClose: function () {
                // console.log('onClose')
            }
        },
        computed: {
            campaign: function () {
                return this.$store.state.campaign
            }
        }
    }
</script>


// WEBPACK FOOTER //
// greek-letters-dropdown.vue?2e8f9678